let env = 'production' //production、release、test
let apiEnv = 'production'
const getEnv = () => {
  return env
}
const setEnv = (envstr) => {
  env = envstr
}
const getApiEnv = () => {
  return apiEnv
}
const setApiEnv = (envstr) => {
  apiEnv = envstr
}
export {
  getEnv,
  setEnv,
  getApiEnv,
  setApiEnv
}
